var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLongDownR(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.75668 8.1716C6.97564 7.39055 6.97564 6.12422 7.75668 5.34317L10.5851 2.51474C11.3662 1.73369 12.6325 1.73369 13.4135 2.51474L16.242 5.34317C17.023 6.12422 17.023 7.39055 16.242 8.1716L13.4135 11C13.2178 11.1958 12.9915 11.3425 12.75 11.4401V15.85H17C17.2981 15.85 17.5679 16.0266 17.6873 16.2997C17.8066 16.5729 17.7529 16.8908 17.5503 17.1096L12.5503 22.5096C12.4084 22.6629 12.2089 22.75 12 22.75C11.7911 22.75 11.5916 22.6629 11.4497 22.5096L6.4497 17.1096C6.24716 16.8908 6.1934 16.5729 6.31275 16.2997C6.4321 16.0266 6.70191 15.85 7.00002 15.85H11.25V11.4407C11.008 11.3431 10.7813 11.1962 10.5851 11L7.75668 8.1716Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLongDownR);
export default __webpack_public_path__ + "static/media/arrow-long-down-r.a96ecba4ae0f7d5559695090a941b99d.svg";
export { ForwardRef as ReactComponent };